export default __webpack_public_path__ + "static/media/book-nav-icon7-hover.728d5927.svg";